export enum ScreenTypes {
  HOME = 'home',
  GAME = 'game',
  WON = 'won',
  LOST = 'lost',
  EXPIRED = 'expired',
  ALREADY_PLAYED = 'alreadyPlayed',
  ERROR = 'error',
  NEXT = 'next',
  COLLECT = 'collect',
  SMART_COLLECT = 'smartCollect',
  SINGLEGAME = 'singleGame',
  MULTIGAME = 'multiGame',
  UNAVAILABLE = 'unavailable',
}
